<template>
  <b-list-group>
    <b-list-group-item
      v-for="(file, index) in data"
      :key="index"
      v-b-tooltip.hover.left="`Cargado el ${timestampToDate(file.fecha)} (${docStatus(file.estado).text})`"
      class="d-flex cursor-pointer"
      :href="`${delivery}${file.rutaDoc}${file.extBase}`"
      target="_blank"
    >
      <span class="mr-1">
        <document-status
          :icon="statusIcon"
          :status="file.estado"
        />
      </span>
      <span class="text-truncate">{{ file.tipoNombre }}</span>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import {
  VBTooltip,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import { docStatus, timestampToDate } from '@core/utils/filter'
import documentStatus from './documentStatus.vue'

export default {
  components: {
    BListGroup,
    BListGroupItem,

    documentStatus,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    statusIcon: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD

    return {
      delivery,
      docStatus,
      timestampToDate,
    }
  },
}
</script>
